import { CmsApiStickyHeaderLinksGradBlockData } from 'modules/cms/api/types/CmsApiStickyHeaderLinksGrad';
import { CmsAmpLinksBlock } from 'modules/cms/blocks/Amp/CmsAmpLinksBlock';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpStickyHeaderLinksGradBlock({
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiStickyHeaderLinksGradBlockData>) {
  return <CmsAmpLinksBlock data={{ ...data, isGrad: true }} />;
}
